enum CheckPermissionStatus {
    InProcess,
    HasAccess,
    NoAccess,
}
export default CheckPermissionStatus;
